import React, { useCallback, useMemo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { CardView, rem } from 'design-system';
import IconSpace from 'design-system/icons/IconSpace';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectFeatureFlag } from 'reducers/selectors';
import { setWalkthroughStep } from 'actions';
import { selectActiveReferralProgramReward } from 'features/inviteFriend/selectors';
import TouchHelper from '../TouchHelper';
import AvatarFeed from '../../avatar-feed/AvatarFeed';
const MainWalkthroughHeaderOverlay = ({ style }) => {
    const colors = useColors();
    const dispatch = useAppDispatch();
    const styles = useStyles(styleSet);
    const status = useAppSelector((store) => store.feed.walkthrough?.status);
    const navHeaderHighlightContent = useAppSelector((store) => store.feed.walkthrough?.navHeaderHighlightContent);
    const withAction = useAppSelector((store) => store.feed.walkthrough?.withAction);
    const count = useAppSelector((store) => store.feed.walkthrough?.count);
    const step = useAppSelector((store) => store.feed.walkthrough?.step);
    const referralButtonFlag = useAppSelector((store) => selectFeatureFlag(store, 'referrals_get_button_feed').value);
    const activeReferralProgram = useAppSelector(selectActiveReferralProgramReward);
    const showReferralsButton = referralButtonFlag && !!activeReferralProgram;
    const handlePressProfile = useCallback(() => {
        if (typeof step === 'number' && count) {
            dispatch(setWalkthroughStep({
                index: step + 1,
                highlightTabIndex: undefined,
                count,
            }));
        }
    }, [count, step]);
    const Content = useMemo(() => {
        if (navHeaderHighlightContent) {
            if (navHeaderHighlightContent === 'spaces') {
                return (<View style={[
                        styles.spaceContainer,
                        !showReferralsButton && styles.spaceContainerWithoutReferrals,
                    ]} pointerEvents="none">
            <CardView style={styles.icon} noMargin>
              <IconSpace color={colors.elements.primary}/>
            </CardView>
          </View>);
            }
            if (navHeaderHighlightContent === 'profile') {
                return (<View style={styles.profileContainer}>
            <View style={styles.profileWrapper}>
              <TouchableOpacity disabled={!withAction} onPress={handlePressProfile}>
                <View pointerEvents="none">
                  <AvatarFeed />
                </View>
              </TouchableOpacity>
            </View>
            {!!withAction && (<View style={styles.touchHelperContainer} pointerEvents="box-none">
                <TouchHelper position="right" onPress={handlePressProfile}/>
              </View>)}
          </View>);
            }
        }
        return null;
    }, [
        colors.elements.primary,
        handlePressProfile,
        navHeaderHighlightContent,
        showReferralsButton,
        styles.icon,
        styles.profileContainer,
        styles.profileWrapper,
        styles.spaceContainer,
        styles.spaceContainerWithoutReferrals,
        styles.touchHelperContainer,
        withAction,
    ]);
    return status === 'in-progress' ? (<View style={[styles.container, style]}>{Content}</View>) : null;
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        position: 'absolute',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        justifyContent: 'flex-end',
        zIndex: 100,
    },
    spaceContainer: {
        paddingBottom: rem(6),
        paddingRight: rem(45),
        alignItems: 'flex-end',
    },
    spaceContainerWithoutReferrals: {
        paddingRight: rem(85),
    },
    profileContainer: {
        paddingLeft: rem(10),
        paddingBottom: rem(10),
    },
    icon: {
        width: rem(48),
        height: rem(48),
        alignItems: 'center',
        justifyContent: 'center',
    },
    profileWrapper: {
        width: rem(48),
        height: rem(48),
        borderRadius: rem(24),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.background.dark,
    },
    touchHelperContainer: {
        position: 'absolute',
        bottom: 0,
        top: -rem(10),
        left: rem(30),
    },
}));
export default MainWalkthroughHeaderOverlay;
